import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { envs } from './config';
import oktaAuthService from './okta';

const httpLink = createHttpLink({
  uri: envs.REACT_APP_GRAPHQL_URI,
});

const authLink = setContext(
  (_, forward: { readonly headers?: Readonly<Record<string, string>> }) => {
    const authenticatedUserAccessToken = oktaAuthService.getAccessToken();

    return {
      headers: {
        ...forward.headers,
        authorization:
          authenticatedUserAccessToken !== undefined
            ? `Bearer ${authenticatedUserAccessToken}`
            : '',
      },
    };
  }
);

const graphQlClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

export default graphQlClient;
